module.exports = __webpack_public_path__ + "static/media/monday-in-german.cd89ccb8.png";